module.exports = __webpack_public_path__ + "img/Botero.a987a1af.png";